import { useLiveQuery } from "dexie-react-hooks";
import type { UserPrefs } from "@recipevault/shared";
import { db } from "../../sync/db.js";
import { patchMe } from "../self/api.js";

const DEFAULT_COOKING_SPLIT: UserPrefs["cookingSplit"] = "60-40";
const DEFAULT_TIMER: UserPrefs["timer"] = { soundEnabled: true, vibrateEnabled: true };
const DEFAULT_MEAL_PLAN_DAILY_EMAIL: UserPrefs["mealPlanDailyEmail"] = true;

export interface UsePrefsResult {
  cookingSplit: UserPrefs["cookingSplit"];
  timer: UserPrefs["timer"];
  mealPlanDailyEmail: UserPrefs["mealPlanDailyEmail"];
  patchPrefs: (partial: Partial<UserPrefs>) => Promise<void>;
}

export function usePrefs(): UsePrefsResult {
  const me = useLiveQuery(() => db.me.get("me"), [], undefined);

  const cookingSplit = me?.user.prefs.cookingSplit ?? DEFAULT_COOKING_SPLIT;
  const timer = me?.user.prefs.timer ?? DEFAULT_TIMER;
  const mealPlanDailyEmail =
    me?.user.prefs.mealPlanDailyEmail ?? DEFAULT_MEAL_PLAN_DAILY_EMAIL;

  async function patchPrefs(partial: Partial<UserPrefs>): Promise<void> {
    const updated = await patchMe({ prefs: partial });
    await db.me.put({ ...updated, _singleton: "me" });
  }

  return { cookingSplit, timer, mealPlanDailyEmail, patchPrefs };
}
